import React, { useState, useEffect } from "react";

const BannerPage = () => {
  const [activeQuadrant, setActiveQuadrant] = useState("Lawyer");

  // State to store file inputs for images
  const [image1, setImage1] = useState(null);
  const [image2, setImage2] = useState(null);
  const [image3, setImage3] = useState(null);

  // State for the fetched data (GET)
  const [fetchedImages, setFetchedImages] = useState(null);

  // Define the API endpoints based on the active quadrant
  const apiEndpoints = {
    Lawyer: "https://admindashboard.clns.in/api/dash/banner_lawyer/",
    Client: "https://admindashboard.clns.in/api/dash/banner_client/",
    Student: "https://admindashboard.clns.in/api/dash/banner_student/",
  };

  // Fetch data (GET) when the component mounts or activeQuadrant changes
  useEffect(() => {
    const fetchImages = async () => {
      try {
        const response = await fetch(apiEndpoints[activeQuadrant]);
        const data = await response.json();
        setFetchedImages(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchImages();
  }, [activeQuadrant]);

  // Handle file change
  const handleFileChange = (e, setter) => {
    setter(e.target.files[0]);
  };

  // Handle submit (POST)
  const handleSubmit = async (e) => {
    e.preventDefault();

    let formData = new FormData();

    // Add the images to FormData
    formData.append("image1", image1);
    formData.append("image2", image2);
    formData.append("image3", image3);

    try {
      // Make the POST request with the form data
      const response = await fetch(apiEndpoints[activeQuadrant], {
        method: "POST",
        body: formData,
      });
      const data = await response.json();
      console.log("Response from server:", data);
    } catch (error) {
      console.error("Error uploading images:", error);
    }
  };

  // Render content based on active quadrant
  const renderContent = () => {
    return (
      <div style={{ padding: "20px" }}>
        <label>Cover Photo 1</label>
        <br />
        <input
          type="file"
          accept="image/*"
          onChange={(e) => handleFileChange(e, setImage1)}
          style={{ marginTop: "10px" }}
        />
        <br />
        <label>Cover Photo 2</label>
        <br />
        <input
          type="file"
          accept="image/*"
          onChange={(e) => handleFileChange(e, setImage2)}
          style={{ marginTop: "10px" }}
        />
        <br />
        <label>Cover Photo 3</label>
        <br />
        <input
          type="file"
          accept="image/*"
          onChange={(e) => handleFileChange(e, setImage3)}
          style={{ marginTop: "10px" }}
        />
      </div>
    );
  };

  return (
    <div style={{ display: "grid", gap: "20px", paddingLeft: "10%" }}>
      <div
        style={{
          border: "1px hidden blue",
          height: "70vh",
          width: "90%",
          borderRadius: "10px",
          backgroundColor: "#f8f9fa",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          boxShadow: "0px 0px 5px rgba(0,0,0,0.1)",
        }}
      >
        <div style={{ display: "flex" }}>
          {["Lawyer", "Client", "Student"].map((quadrant, index) => (
            <button
              key={index}
              onClick={() => setActiveQuadrant(quadrant)}
              style={{
                width: "40%",
                backgroundColor: activeQuadrant === quadrant ? "darkblue" : "blue",
                color: "white",
                height: "35px",
                border: "none",
                borderTopLeftRadius: index === 0 ? "5px" : "0",
                borderTopRightRadius: index === 3 ? "5px" : "0",
                cursor: "pointer",
              }}
            >
              {quadrant}
            </button>
          ))}
        </div>
        {/* Content Rendering */}
        <div style={{ flexGrow: 1 }}>{renderContent()}</div>
      </div>

      {/* Display Fetched Images */}
      <div style={{ paddingTop: "20px" }}>
        <h3>Fetched Images</h3>
        {fetchedImages && (
          <div>
            {fetchedImages.image1 && (
              <img
                src={fetchedImages.image1}
                alt="Image 1"
                style={{ width: "100px", margin: "10px" }}
              />
            )}
            {fetchedImages.image2 && (
              <img
                src={fetchedImages.image2}
                alt="Image 2"
                style={{ width: "100px", margin: "10px" }}
              />
            )}
            {fetchedImages.image3 && (
              <img
                src={fetchedImages.image3}
                alt="Image 3"
                style={{ width: "100px", margin: "10px" }}
              />
            )}
          </div>
        )}
      </div>

      {/* Buttons Section */}
      <div
        style={{
          width: "90%",
          display: "flex",
          justifyContent: "flex-end",
          gap: "20px",
          padding: "10px",
        }}
      >
        <button
          style={{
            backgroundColor: "#e0e0e0",
            color: "black",
            border: "1px solid lightgray",
            padding: "8px 16px",
            borderRadius: "5px",
            cursor: "pointer",
            width: "20%",
          }}
          onClick={() => console.log("Reset Clicked")}
        >
          Reset
        </button>
        <button
          style={{
            backgroundColor: "#007bff",
            color: "white",
            border: "none",
            padding: "8px 16px",
            borderRadius: "5px",
            cursor: "pointer",
            width: "20%",
          }}
          onClick={handleSubmit}
        >
          Save
        </button>
      </div>
    </div>
  );
};

export default BannerPage;
